import { EmailBox } from '@apply/components';
import { useBrokerNewReferralStore } from '../../../state/useBrokerNewReferralStore';

interface RepresentativeEmailProps {
    required?: boolean;
}

export const RepresentativeEmail: React.FC<RepresentativeEmailProps> = ({ required = false }) => {
    const label = 'Email Address';
    const value = useBrokerNewReferralStore((s) => s.referral.repEmail);
    const setValue = useBrokerNewReferralStore((s) => s.set_repEmail);
    return (
        <>
            <EmailBox
                id='representativeEmailTextBox'
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={required}
                width='100%'
            />
        </>
    );
};
